export const signInConstants = {
  SIGN_IN_USER: 'SIGN_IN_USER',
  SIGN_OUT_USER: 'SIGN_OUT_USER',
  FETCH_USER: 'FETCH_USER',
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  CLEAR_ERROR: 'sigin/CLEAR_ERROR',
};
